module.exports = __webpack_public_path__ + "static/media/meetTheTeam.209942f2.jpg";